var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.264 512.264",
    height: 512,
    viewBox: "0 0 512.264 512.264",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m485.456 256.132-19.622-53.857h18.657v-98.857h-54.673l-25.134-68.989h-99.123v-34.429h-98.857v34.429h-99.124l-25.135 68.989h-54.673v98.857h18.657l-19.622 53.857 19.622 53.857h-18.657v98.857h54.673l25.135 68.989h99.123v34.429h98.857v-34.429h99.123l25.135-68.989h54.673v-98.857h-18.657zm-30.965-83.857h-38.857v-38.857h38.857zm-217.788-142.275h38.857v38.857h-38.857zm-178.931 103.417h38.858v38.857h-38.858zm0 206.572h38.858v38.857h-38.858zm217.789 142.275h-38.857v-38.857h38.857zm108.123-34.429h-78.123v-34.429h-98.857v34.429h-78.124l-14.205-38.989h12.254v-98.857h-48.27l-19.622-53.857 19.622-53.857h48.271v-98.857h-12.254l14.205-38.989h78.123v34.429h98.857v-34.429h78.123l14.205 38.989h-12.255v98.857h48.271l19.622 53.857-19.622 53.857h-48.271v98.857h12.254zm70.807-68.989h-38.857v-38.857h38.857z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.78e96b1a.svg";
export { ForwardRef as ReactComponent };